import React from 'react';

import BOOKMARKED_SEARCHES_LS from 'shared-constants/src/bookmarksLSRecord';

import { propTypeGroup, propTypeGroupValuesRent } from 'shared-constants/src/filters';
import { filtersOrder } from 'shared-constants/src/filters/groups';

import isObject from 'shared-utils/src/checkVarType/isObject';
import createLabelSentence from 'shared-utils/src/createLabelSentence';
import { computeActiveFilters } from 'shared-utils/src/helpersMyCasa';
import { getItem } from 'shared-utils/src/localStorage';

import { notificationsValues } from './constants';
import { getBookmarkPayload } from './callapi';

const keys = el => Object.keys(el);
const firstkey = el => el[keys(el)[0]];

const fitersOrderWithSelectors = () => {
  const clone = { ...filtersOrder };
  keys(clone).forEach(f => clone[f] += 2);
  return {
    license_type_groups: 1,
    includes_property_ownership: 2,
    ...clone,
  };
}

export const checkNotificationIsEnabled = (name, searchIsSaved, bookmarkData) => {
  if (
    searchIsSaved
    && bookmarkData
    && bookmarkData.alerts
  ) {
    const alert = bookmarkData.alerts.filter(x => x.alertType === name)[0];
    if (alert && alert.alertFrequency === notificationsValues.never.value) {
      return false;
    }
  }
  return true;
};

export const checkNotificationFrequency = (name, searchIsSaved, bookmarkData, forceFrequency) => {
  if (
    searchIsSaved
    && bookmarkData
    && bookmarkData.alerts
  ) {
    const alert = bookmarkData.alerts.filter(x => x.alertType === name)[0];
    return alert
      ? alert.alertFrequency
      : notificationsValues.never.value;
  } else if (forceFrequency) {
    return forceFrequency;
  }
  return notificationsValues.immediately.value;
};

export const getTitle = ({
  locations,
  publisher,
  nearby,
  bookmarkData,
}) => {
  if (bookmarkData && bookmarkData.name) {
    return bookmarkData.name;
  }
  if (nearby) {
    return nearby.name;
  }
  const publisherStart = publisher
    ? `Immobili di ${publisher} `
    : '';

  let publisherEnd = publisher
    ? `in tutta Italia`
    : '';
  let localities = '';
  if (locations.length) {
    publisherEnd = '';

    if (locations.length > 1 && locations[0].level === 120) {
      const { parent: { town: { name } } } = locations[0];
      localities = `Intorno alle fermate ${locations.map(l => l.name).join(', ')} a ${name}`;
    } else {
      localities = locations.map((loc) => {
        const { name, level, parent } = loc;
        switch (level) {
          case 999:
            return name;
          case 132:
            return `${name} (${parent.nonadminzone.name})`;
          case 130:
            return `${name}`;
          case 120:
            return `Intorno alla fermata ${name} a ${parent.town.name}`;
          case 118:
            return `Sulla ${name}`;
          case 11:
          case 10:
            return `${name} (${parent.town.name})`;
          case 9:
            return `${name} (${parent.province.short})`;
          case 6:
            return `${name} (provincia)`;
          default:
            return `in ${name};`
        }
      }).filter(Boolean).join(', ');
    }
  }
  return `${publisherStart}${localities}${publisherEnd}`;
};

export const getNotificationsTitle = ({ values, isFromNotRegisteredUser = false }) => {
  let hasNotifications = false;
  let titStart = 'notifiche';
  let titEnd = 'non Attive';

  const {
    hasPush,
    hasEmail,
    emailFrequency,
  } = values;

  if (isFromNotRegisteredUser) {
    if (hasPush && hasEmail) {
      titStart = `con ${titStart}`;
      hasNotifications = true;
      if (emailFrequency === 'immediately') {
        titEnd = 'immediate';
      } else {
        titEnd = 'una volta al giorno';
      }
    }
    return { hasNotifications, titStart, titEnd };

  }


  if (hasPush || hasEmail) {
    hasNotifications = true;
    titStart = `con ${titStart}`;
    if (hasPush && hasEmail) {
      titEnd = 'su App e via Email';
    } else if (hasPush) {
      titEnd = 'su App';
    } else {
      titEnd = 'via Email';
    }
  }

  return { hasNotifications, titStart, titEnd };
};

export const getSearchWhat = (pTypeGroup, pTypes) => {
  if (pTypes.length) {
    return pTypes.join(', ');
  }
  const [shorRent] = propTypeGroupValuesRent;
  const groups = [...propTypeGroup.values, shorRent];
  return groups.filter((group) => group.value === pTypeGroup)[0]?.display || 'Casa';
};

const validRangeValue = (value) => value && value !== 'all' ? value : null;

const getRangeFilters = (filters) => {
  const filtersClone = { ...filters };
  const filterNames = Object.keys(filtersClone);
  const ranges = filterNames.filter(name => name.includes('Min') || name.includes('Max'));
  const res = {};
  ranges.forEach((el) => {
    const isMin = el.includes('Min');
    let filterName = isMin
      ? el.replace('Min', '')
      : el.replace('Max', '');

    const name = filterName === 'numRooms' ? 'rooms' : filterName
    if (!res[`${name}`]) {
      res[`${name}`] = {};
    }
    res[`${name}`][el] = validRangeValue(filtersClone[el]);
    delete filtersClone[el];
  });
  return { ...filtersClone, ...res };
};

export const getUsableFilters = (filters, auctionFilter) => {
  const usable = getRangeFilters(computeActiveFilters(filters).activeFiltersList);

  if (!usable.channel) {
    usable.channel = 'vendita';
  }
  if (!usable.propertyTypeGroup) {
    if (!usable.category || usable.category === 'residenziale') {
      usable.propertyTypeGroup = 'case';
    } else {
      usable.propertyTypeGroup = usable.category;
    }
  }
  if (auctionFilter) {
    usable.is_auction = false;
  }
  delete usable.category;
  return usable;
};

export const getUsableLocations = ({
  locations = [],
  nearby = null,
  poi = null,
  poiNamesList = null,
}) => {
  
  let mainLocation = '';
  let secondaryLocation = '';
  let tertiaryLocation = '';
  if (nearby) {
    mainLocation = <>a {nearby.time} min. {nearby.vehicle} da <strong className="tp-w--l">{nearby.name}</strong></>;
  }
  if (locations.length) {
    const isMultipleLocations = locations.length > 1;
    const { name, level, levels } = locations[0]

    if (isMultipleLocations) {
      if (level === 132) {
        mainLocation = <>a <strong className="tp-w--l">{levels.L130}</strong></>;
        secondaryLocation = <>in <strong className="tp-w--l">{locations.map((loc) => loc.name).join(' • ')}</strong></>
      }else if (level === 120) {
        mainLocation = <>a <strong className="tp-w--l">{levels.L9}</strong></>;
        secondaryLocation = <>sulla <strong className="tp-w--l">{levels.L118}</strong></>;
        tertiaryLocation = <>intorno alle <strong className="tp-w--l">fermate {locations.map((loc) => loc.name).join(' • ')}</strong></>
      } else if (level === 9) {
        mainLocation = <>a <strong className="tp-w--l">{levels.L6} (provincia)</strong></>;
        secondaryLocation = <>nei comuni <strong className="tp-w--l">{locations.map((loc) => loc.name).join(' • ')}</strong></>
      } else {
        mainLocation = <>a <strong className="tp-w--l">{levels.L9}</strong></>;
        secondaryLocation = <>in zona <strong className="tp-w--l">{locations.map((loc) => loc.name).join(' • ')}</strong></>
      }
    } else {
      switch (level) {
        case 132:
          mainLocation = <>a <strong className="tp-w--l">{levels.L130}</strong></>;
          secondaryLocation = <>in <strong className="tp-w--l">{levels.L132}</strong></>;
          break;
        case 130:
          mainLocation = <>a <strong className="tp-w--l">{levels.L130}</strong></>;
          secondaryLocation = <>in <strong className="tp-w--l">Tutta l'area</strong></>;
          break;
        case 120:
          mainLocation = <>a <strong className="tp-w--l">{levels.L9}</strong></>;
          secondaryLocation = <>sulla <strong className="tp-w--l">{levels.L118}</strong></>;
          tertiaryLocation = <>intorno alla <strong className="tp-w--l">fermata {name}</strong></>
          break;
        case 118:
          mainLocation = <>a <strong className="tp-w--l">{levels.L9}</strong></>;
          secondaryLocation = <>sulla <strong className="tp-w--l">{name}</strong></>
          tertiaryLocation = <>intorno a <strong className="tp-w--l">Tutte le fermate</strong></>
          break;
        case 11:
        case 10:
          mainLocation = <>a <strong className="tp-w--l">{levels.L9}</strong></>;
          secondaryLocation = <>in zona <strong className="tp-w--l">{name}</strong></>
          break;
        case 9:
          mainLocation = <>a <strong className="tp-w--l">{name}</strong></>;
          secondaryLocation = <>in <strong className="tp-w--l">Tutto il comune</strong></>
          break;
        case 6:
          mainLocation = <>a <strong className="tp-w--l">{name}</strong></>;
          secondaryLocation = <>in <strong className="tp-w--l">Tutta la provincia</strong></>
          break;
        default:
          mainLocation = <>in <strong className="tp-w--l">{name}</strong></>;
      }
    }
  }
  let activePoi = '';
  if (poi && poiNamesList) {
    activePoi = <>vicino a <strong className="tp-w--l">{poiNamesList[keys(poi)[0]].name}</strong></>;
  }
  return {
    mainLocation,
    secondaryLocation,
    tertiaryLocation,
    activePoi,
  };
};

export const getFiltersResume = (allFilters) => {
  const filtersToIgnore = [
    'channel',
    'propertyTypeGroup',
    'propertyTypes',
    'poi',
    'nearby',
    'sortType',
    'q',
  ];

  const order = fitersOrderWithSelectors();
  let filters = keys(allFilters).map((filter) => {
    if (!filtersToIgnore.includes(filter)) {
      return ({
        [filter]: {
          display: createLabelSentence(filter, isObject(allFilters[filter]) ? allFilters[filter] : allFilters),
          order: order[filter],
        },
      });
    }
    return null;
  }).filter(Boolean);
  if (filters.length) {
    filters = filters.sort((a, b) => firstkey(a).order - firstkey(b).order);
    filters = filters.map(f => firstkey(f).display);
  }
  return filters;
};

const getBookmarkNotifications = ({ notifications = {} }) => {
  const res = [];
  const alertFrequencyEmail = notifications.hasEmail ? notifications.emailFrequency : notificationsValues.never.value;
  const alertFrequencyPush = notifications.hasPush ? notifications.pushFrequency : notificationsValues.never.value;

  res.push({
    searchAlertId: 0,
    alertType: 'push',
    alertFrequency: alertFrequencyPush,
  });
  res.push({
    searchAlertId: 0,
    alertType: 'mail',
    alertFrequency: alertFrequencyEmail
  });

  return res.length
    ? { alerts: res }
    : null;
};

const getExcludeAuctionValue = ({
  excludeAuctions,
  bookmarkUrl,
}) => excludeAuctions
    ? {
      exclude_auction: true,
      searchUrl: bookmarkUrl.indexOf('?') > -1
        ? `${bookmarkUrl}&exclude_auction=true`
        : `${bookmarkUrl}?exclude_auction=true`,
    } : null;

export const getCallSaveSearchBody = ({
  bkmPayload,
  title,
  notifications,
  excludeAuctions,
}) => {
  const {
    searchData,
    searchData: {
      encodedProperties,
      encodedProperties: {
        searchUrl,
      },
    },
  } = bkmPayload;

  const newSearchData = {
    ...searchData,
    name: title,
    encodedProperties: {
      ...encodedProperties,
      ...getExcludeAuctionValue({ excludeAuctions, bookmarkUrl: searchUrl }),
    },
    ...getBookmarkNotifications({ notifications }),
  };
  const body = {
    ...bkmPayload,
    searchData: newSearchData,
  };

  return body;
};

export const getUpdateSavedSearchBody = ({
  searchTitle,
  notifications,
  bookmarkData,
  user,
  bkmPayload,
}) => {
  const {
    hasPush,
    pushFrequency,
    hasEmail,
    emailFrequency,
  } = notifications;

  const {
    searchData: {
      encodedProperties,
    },
  } = bkmPayload;

  let mailAlertId = 0;
  let pushAlertId = 0;

  if (bookmarkData) {
    const mail = (bookmarkData.alerts || []).filter(x => x.alertType === 'mail')[0];
    mailAlertId = mail
      ? mail.searchAlertId
      : 0;
    const push = (bookmarkData.alerts || []).filter(x => x.alertType === 'push')[0];
    pushAlertId = push
      ? push.searchAlertId
      : 0;
  }

  return {
    user,
    searchId: bookmarkData.searchId,
    data: {
      name: searchTitle,
      encodedProperties,
      alerts: [
        {
          alertType: 'push',
          alertFrequency: hasPush ? pushFrequency : notificationsValues.never.value,
          searchAlertId: pushAlertId,
        },
        {
          alertType: 'mail',
          alertFrequency: hasEmail ? emailFrequency : notificationsValues.never.value,
          searchAlertId: mailAlertId,
        },
      ],
    },
  };
};

export const getProvince = (loc) => {
  let province = null;
  if (!loc) {
    return province;
  }
  if (loc) {
    const {
      name,
      level,
      parent,
    } = loc;
    if (loc.level === 999) {
      return province;
    } else if (level === 6) {
      province = name;
    } else if (level > 6) {
      province = parent?.province?.name;
    }
  }
  return province;
};

export const getLsRecords = () => {
  const ls = getItem(BOOKMARKED_SEARCHES_LS) || {};
  const savedsearchesData = ls.savedsearchesData || [];
  const provinces = ls.provinces || [];
  return { savedsearchesData, provinces };
};

const formatAlerts = (notifications, bookmarkData) => {
  const alerts = [];

  let mailBkmData;
  let pushBkmData;
  if (bookmarkData) {
    mailBkmData = bookmarkData.alerts.filter(x => x.alertType === 'mail')[0];
    pushBkmData = bookmarkData.alerts.filter(x => x.alertType === 'push')[0];
  }

  if (notifications.hasEmail) {
    let mailData = { alertType: 'mail', alertFrequency: notifications.emailFrequency };
    if (mailBkmData) {
      mailData = {
        ...mailBkmData,
        alertFrequency: notifications.emailFrequency,
      };
    }
    alerts.push(mailData);
  } else if (mailBkmData) {
    const mailData = {
      ...mailBkmData,
      alertFrequency: notificationsValues.never.value,
    };
    alerts.push(mailData);
  }
  if (notifications.hasPush) {
    let pushData = { alertType: 'push', alertFrequency: notifications.pushFrequency };
    if (pushBkmData) {
      pushData = {
        ...pushBkmData,
        alertFrequency: notifications.pushFrequency,
      };
    }
    alerts.push(pushData);
  } else if (pushBkmData) {
    const pushData = {
      ...pushBkmData,
      alertFrequency: notificationsValues.never.value,
    };
    alerts.push(pushData);
  }
  return alerts;
};

export const getBookmarkSummary = (title, filters, notifications, searchUrl, bookmarkData) => {
  return {
    name: title,
    filters: {
      tr: filters.tr || filters.channel,
      propertyTypeGroup: filters.propertyTypeGroup || filters.category,
      propertyTypes: filters.propertyTypes || [],
      ...computeActiveFilters(filters).activeFiltersList,
    },
    alerts: formatAlerts(notifications, bookmarkData),
    uri: searchUrl,
  };
};

export const getCreateAlertsEventLabel = (notifications, type) => {
  if (type === 'email') {
    if (notifications.hasEmail && notifications.emailFrequency !== notificationsValues.never.value) {
      return notifications.emailFrequency === notificationsValues.immediately.value
        ? notificationsValues.immediately.track
        : notificationsValues.daily.track;
    }
    return notificationsValues.never.track;
  }
  if (notifications.hasPush && notifications.pushFrequency !== notificationsValues.never.value) {
    return notifications.pushFrequency === notificationsValues.immediately.value
      ? notificationsValues.immediately.track
      : notificationsValues.daily.track;
  }
  return notificationsValues.never.track;
};

/**
 * 
 * @param {bkm} paramN tutti i parametri necessari per creare il body della search
 * come filtri, locs, notifiche, ecc
 * Crea il body per la chiamata di creazione della request per la search
 * @returns 
 */

export const createReqBodySaveSearch = async ({
  filters,
  locations,
  activeNearby,
  total,
  user,
  domain,
  title,
  notifications,
  excludeAuctions,
}) => {

  const bkmPayload = await getBookmarkPayload({
    filters,
    locations,
    activeNearby,
    total,
    user,
    domain,
  });

  const reqBody = getCallSaveSearchBody({
    bkmPayload,
    title,
    notifications,
    excludeAuctions,
  });

  return reqBody?.searchData;

}